import type { ButtonHTMLAttributes, JSX } from 'react';

import * as styles from './Button.css.js';

export type ButtonVariant = keyof typeof styles.variant;
export type ButtonSize = keyof typeof styles.size;

export type ButtonProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  readonly size?: ButtonSize;
  readonly variant?: ButtonVariant;
};

export function Button({
  className,
  size = 'middle',
  type = 'button',
  variant = 'default',
  ...props
}: ButtonProps): JSX.Element {
  return (
    <button
      data-size={size}
      data-slot="button"
      data-variant={variant}
      {...props}
      className={[styles.button, styles.variant[variant], styles.size[size], className]
        .filter(Boolean)
        .join(' ')}
      type={type}
    />
  );
}
